<template>
    <div class="settings-summary-items-v3">
        <h4 class="typographies-paragraph-large-semibold settings-summary-items-v3__subtitle">
            {{ licensesNumber }}
            {{ $l10n.n__('utilisateur', 'utilisateurs', licensesNumber) }}
        </h4>
        <ul class="settings-summary-items-v3-listing">
            <li
                v-for="(item, index) in listLicences"
                :key="index"
                class="settings-summary-items-v3-listing__item typographies-paragraph-medium-regular"
            >
                <div class="settings-summary-items-v3-listing__item-label">
                    <span>
                        <span v-if="item.quantity > 1">{{ item.quantity }}</span>
                        {{ item.label }}
                    </span>
                    <ChargebeeUpsellTag
                        v-if="hasTag(item)"
                        :quantity="item.updatedQuantity"
                        :label="tagLabel(item)"
                        :show-quantity="!isOption(item)"
                    />
                </div>
                <div class="upsell-summary-v3-items-listing__item-price">
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.amount)) }}
                    </span>
                    <span v-if="item.recurrence" class="typographies-paragraph-small-regular">
                        /{{ recurrence(item.recurrence) }}
                    </span>
                </div>
            </li>
        </ul>
        <h4 class="typographies-paragraph-large-semibold settings-summary-items-v3__subtitle">
            {{ $l10n.__('Options') }}
        </h4>
        <ul class="settings-summary-items-v3-listing">
            <li
                v-for="(item, index) in listOptions"
                :key="index"
                class="settings-summary-items-v3-listing__item typographies-paragraph-medium-regular"
            >
                <div class="settings-summary-items-v3-listing__item-label">
                    <span>
                        <span v-if="item.quantity > 1">{{ item.quantity }}</span>
                        {{ item.label }}
                    </span>
                </div>
                <div class="settings-summary-items-v3-listing__item-price">
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.amount)) }}
                    </span>
                    <span v-if="item.recurrence" class="typographies-paragraph-small-regular">
                        /{{ recurrence(item.recurrence) }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import ChargebeeUpsellV3Mixin from './ChargebeeUpsellV3Mixin';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';
import ChargebeeUpsellTag from 'vcomponents/pages/account/upsell/ChargebeeUpsellTag.vue';

export default {
    components: { ChargebeeUpsellTag },
    mixins: [ChargebeeUpsellMixin, ChargebeeUpsellV3Mixin],
    computed: {
        licensesNumber() {
            return this.listLicences.reduce((acc, item) => acc + item.quantity, 0);
        },
        listLicences() {
            return this.subscriptionItemsToBeDisplayed.filter((addon) =>
                addon.item_price_id.includes('pack_crm'),
            );
        },
        listOptions() {
            return this.subscriptionItemsToBeDisplayed.filter(
                (addon) => !addon.item_price_id.includes('pack_crm'),
            );
        },
    },
};
</script>

<style scoped lang="scss">
.settings-summary-items-v3 {
    &__subtitle {
        margin-bottom: var(--spacing-1);
    }
    &-heading {
        display: flex;
        justify-content: space-between;
        margin: 0;
    }

    &-listing {
        margin: 0;

        &__item {
            display: flex;
            justify-content: space-between;

            &-price {
                white-space: nowrap;
            }

            &-label {
                display: flex;
                align-items: center;
                margin-bottom: var(--spacing-0);
            }

            &-price {
                white-space: nowrap;
            }
        }
        &:last-of-type {
            padding-bottom: var(--spacing-4);
            border-bottom: solid 1px var(--colors-common-border-default);
        }
    }
}
</style>
